import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../../common/http/http-provider.service';
import { TestTypeDTO } from '../../../admin/model/test-type.entity';
import { MasterDTO } from '../../../admin/model/admin.entity';
import { PartnerDTO } from '../../../admin/model/partner.entity';
import { GroupDTO } from '../../../admin/model/group.entity';
import { CountryDTO } from '../../../admin/model/country.entity';

@Injectable()
export class AdminDataRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }

  getCerType() {
    return this.get('certificateType/getAll');
  }

  getCertificateTypeById(id:number){
    return this.get(`certificateType/certificateType/`+ id);
  }
  
  getElementType() {
    return this.get('constructionElementTypeQuery/getAll');
  }

  getCostType() {
    return this.get('costType/getAll');
  }

  getCountry() {
    return this.get('country/getAll');
  } 

  getFrame() {
  return this.get(`frame/getAll`);
  }

  getUnmappedFrame() {
  return this.get(`frame/getUnmappedFrame`);
  }
  
  getFrameById(id:number) {
    return this.get('frame/getFrameById/'+id);
  }

  getFrameName() {
    return this.get('frameName/getAll');
  }

  getMountingDirection() {
    return this.get('mountingDirection/getAll');
  }
  getSupportingConstruction() {
    return this.get('supportingConstruction/getAll');
  }

  getGlassBehaviour() {
    return this.get('glassBehavior/getAll');
  }

  getFrameMaterial() {
    return this.get('frameMaterial/getAll');
  }

  getGlassCoatingCode() {
    return this.get('glassCoatingCode/getAll');
  }

  getGlassManufacturer() {
    return this.get('glassManufacturer/getAll');
  }

  getGlassType() {
    return this.get('glassType/getAll');
  }

  getGlassUnit() {
    return this.get('glassUnit/getAll');
  }

  getResultUnit() {
    return this.get('resultUnit/getAll');
  }

  getBeadPosition() {
    return this.get('beadPosition/getAll');
  }

  getComponentCausedFailure() {
    return this.get('componentCausedFailure/getAll');
  }

  getGroup() {
    return this.get('group/getAll');
  }

  getGroupType() {
    return this.get('groupType/getAll');
  }

  getInstitute() {
    return this.get('institute/getAll');
  }

  getInstituteType() {
    return this.get('instituteType/getAll');
  }

  getOrganisationalUnit() {
    return this.get('organisationalUnit/getAll');
  }

  getPartner() {
    return this.get('partner/getAll');
  }

  getPartnerType() {
    return this.get('partnerType/getAll');
  }

  getPerformanceCriteria() {
    return this.get('performanceCriteria/getAll');
  }

  
  getAllPerformanceCriteria() {
    return this.get('masters/getAllPerfCriteria');
  }
  getPrjConfidentialityLvl() {
    return this.get('confidentialityLevel/getAll');
  }

  getOwnerType() {
    return this.get('ownerType/getAll');
  }

  getPrjPurpose() {
    return this.get('purpose/getAll');
  }

  getPrjStatus() {
    return this.get('status/getAll');
  }

  getRegion() {
    return this.get('region/getAll');
  }

  getStandard() {
    return this.get('standard/getAll');
  }

  getPartners() {
    return this.get('partner/getAll');
  }
   getFrameMaterials() {
    return this.get('frameMaterial/getAll');
  }
  
  getTestPurpose() {
    return this.get('testPurpose/getAll');
  }

  getTestType() {
    return this.get('testType/getAll');
  }
  getResultFailureReason() {
    return this.get('resultFailureReason/getAll');
  }

  getTestTypeById(id:number){
    return this.get(`testType/testType/`+ id);
  }

  getStandardById(id: number){
    return this.get(`standard/getStandardById/`+ id);
  }

  getPerformanceCriteriaById(id: number){
    return this.get(`performanceCriteria/getPerformanceCriteriaById/` + id);
  }
 
  //EndRegion Get

  //Region Save
  saveCertificateType(cerType: MasterDTO) {
    return this.post('certificateType/Save', cerType);
  }

  saveConstructionElementType(constElementType: MasterDTO) {
    return this.post('constructionElementType/Save', constElementType);
  }

  saveCostType(costType: MasterDTO) {
    return this.post('costType/Save', costType);
  }

  saveCountry(country: CountryDTO) {
    return this.post('country/Save', country);
  }
  saveFrameName(frameName: MasterDTO) {
    return this.post('frameName/Save', frameName);
  }
  saveMountingDirection(mountingDirection: MasterDTO) {
    return this.post('mountingDirection/Save', mountingDirection);
  }
  saveSupportingConstruction(supportingConstruction: MasterDTO) {
    return this.post('supportingConstruction/Save', supportingConstruction);
  }
  saveGlassBehaviour(glassBehavior: MasterDTO) {
    return this.post('glassBehavior/Save', glassBehavior);
  }

  saveFrameMaterial(frameMaterial: MasterDTO) {
    return this.post('frameMaterial/Save', frameMaterial);
  }

  saveGlassCoatingCode(glassCoatingCode: MasterDTO) {
    return this.post('glassCoatingCode/Save', glassCoatingCode);
  }

  saveGlassManufacturer(glassManufacturer: MasterDTO) {
    return this.post('glassManufacturer/Save', glassManufacturer);
  }

  saveGlassType(glassType: MasterDTO) {
    return this.post('glassType/Save', glassType);
  }

  saveGlassUnit(glassUnit: MasterDTO) {
    return this.post('glassUnit/Save', glassUnit);
  }

  saveResultUnit(resultUnit: MasterDTO) {
    return this.post('resultUnit/Save', resultUnit);
  }

  saveBeadPosition(beadPosition: MasterDTO) {
    return this.post('beadPosition/Save', beadPosition);
  }

  saveComponentCausedFailure(resultUnit: MasterDTO) {
    return this.post('componentCausedFailure/Save', resultUnit);
  }

  saveGroup(group: GroupDTO) {
    return this.post('group/Save', group);
  }

  saveGroupType(groupType: MasterDTO) {
    return this.post('groupType/Save', groupType);
  }

  saveInstitute(institute: MasterDTO) {
    return this.post('institute/Save', institute);
  }

  saveInstituteType(instituteType: MasterDTO) {
    return this.post('instituteType/Save', instituteType);
  }

  saveOrganisationalUnit(organisationalUnit: MasterDTO) {
    return this.post('organisationalUnit/Save', organisationalUnit);
  }

  savePartner(partner: PartnerDTO) {
    return this.post('partner/Save', partner);   
  }

  savePartnerType(partnerType: MasterDTO) {
    return this.post('partnerType/Save', partnerType);  //dependent
  }

  savePerformanceCriteria(performanceCriteria: MasterDTO) {
    return this.post('performanceCriteria/Save', performanceCriteria);
  }

  savePrjConfidentialityLvl(confidentialityLevel: MasterDTO) {
    return this.post('confidentialityLvl/Save', confidentialityLevel);
  }

  savePrjOwnerType(ownerType: MasterDTO) {
    return this.post('ownerType/Save', ownerType);
  }

  savePrjPurpose(prjPurpose: MasterDTO) {
    return this.post('prjPurpose/Save', prjPurpose);   //Doubt
  }

  savePrjStatus(prjStatus: MasterDTO) {
    return this.post('prjStatus/Save', prjStatus);
  }

  saveRegion(region: MasterDTO) {
    return this.post('region/Save', region);
  }

  saveStandard(standard: MasterDTO) {
    return this.post('standard/Save', standard);     //dependent
  }

  saveTstPurpose(tstPurpose: MasterDTO) {
    return this.post('tstPurpose/Save', tstPurpose);
  }

  saveTstType(tstType: TestTypeDTO) {
    return this.post('testType/Save', tstType);    //dependent
  }

  saveUpdateFrame(frame: MasterDTO) {
    return this.put('frame/SaveUpdateFrame', frame);
  }

  saveResultFailureReason(result: MasterDTO) {
    return this.post('resultFailureReason/Save', result);
  }
   //EndRegion Save

  //Region Put
  updateCertificateType(cerType: MasterDTO) {
    return this.put('certificateType/Update', cerType);
  }

  updateConstructionElementType(constElementType: MasterDTO) {
    return this.put('constructionElementType/Update', constElementType);
  }

  updateCostType(costType: MasterDTO) {
    return this.put('costType/Update', costType);
  }

  updateCountry(country: CountryDTO) {
    return this.put('country/Update', country);
  }
  updateFrameName(frameName: MasterDTO) {
    return this.put('frameName/Update', frameName);
  }
  updateMountingDirection(mountingDirection: MasterDTO) {
    return this.put('mountingDirection/Update', mountingDirection);
  }
  updateSupportingConstruction(supportingConstruction: MasterDTO) {
    return this.put('supportingConstruction/Update', supportingConstruction);
  }
  updateGlassBehaviour(glassBehaviour: MasterDTO) {
    return this.put('glassBehavior/Update', glassBehaviour);
  }
  updateFrameMaterial(frameMaterial: MasterDTO) {
    return this.put('frameMaterial/Update', frameMaterial);
  }

  updateGlassCoatingCode(glassCoatingCode: MasterDTO) {
    return this.put('glassCoatingCode/Update', glassCoatingCode);
  }

  updateGlassManufacturer(glassManufacturer: MasterDTO) {
    return this.put('glassManufacturer/Update', glassManufacturer);
  }

  updateGlassType(glassType: MasterDTO) {
    return this.put('glassType/Update', glassType);
  }

  updateGlassUnit(glassUnit: MasterDTO) {
    return this.put('glassUnit/Update', glassUnit);
  }

  updateResultUnit(resultUnit: MasterDTO) {
    return this.put('resultUnit/Update', resultUnit);
  }

  updateBeadPosition(beadPosition: MasterDTO) {
    return this.put('beadPosition/Update', beadPosition);
  }

  updateComponentCausedFailure(resultUnit: MasterDTO) {
    return this.put('componentCausedFailure/Update', resultUnit);
  }

  updateGroup(group: GroupDTO) {
    return this.put('group/Update', group);
  }

  updateGroupType(groupType: MasterDTO) {
    return this.put('groupType/Update', groupType);
  }

  updateInstitute(institute: MasterDTO) {
    return this.put('institute/Update', institute);     //dependent
  }

  updateInstituteType(instituteType: MasterDTO) {
    return this.put('instituteType/Update', instituteType);
  }

  updateOrganisational(organisationalUnit: MasterDTO) {
    return this.put('organisationalUnit/Update', organisationalUnit);
  }

  updatePartner(partner: PartnerDTO) {
    return this.put('partner/Update', partner);    //dependent
  }

  updatePartnerType(partnerTYpe: MasterDTO) {
    return this.put('partnerType/Update', partnerTYpe);    //dependent
  }

  updatePerformanceCriteria(performanceCriteria: MasterDTO) {
    return this.put('performanceCriteria/Update', performanceCriteria);
  }

  updateConfidentialityLvl(confidentialityLevel: MasterDTO) {
    return this.put('confidentialityLvl/Update', confidentialityLevel);
  }

  updateOwnerType(ownerType: MasterDTO) {
    return this.put('ownerType/Update', ownerType);
  }

  updatePrjPurpose(prjPurpose: MasterDTO) {
    return this.put('prjPurpose/Update', prjPurpose);   //indentity error
  }

  updatePrjStatus(prjStatus: MasterDTO) {
    return this.put('prjStatus/Update', prjStatus);   //indentity error
  }

  updateRegion(region: MasterDTO) {
    return this.put('region/Update', region);
  }

  updateStandard(standard: MasterDTO) {
    return this.put('standard/Update', standard);  // dependent
  }

  updateTstPurpose(tstPurpose: MasterDTO) {
    return this.put('tstPurpose/Update', tstPurpose);
  }

  updateTstType(tstType: TestTypeDTO) {
    return this.put('testType/Update', tstType);  //dependent
  }
  updateResultFailureReason(reason: MasterDTO) {
    return this.put('resultFailureReason/Update', reason);  
  }


  //EndRegion Put


  //Region Delete

  deleteCertificateType(id: number) {
    return this.delete(`certificateType/Delete/`+ id);
  }

  deleteConstructionElementType(id: number) {
    return this.delete(`constructionElementType/Delete/`+ id);
  }

  deleteCostType(id: number) {
    return this.delete('costType/Delete/'+ id);
  }

  deleteCountry(id: number) {
    return this.delete('country/Delete/'+ id);
  }
  deleteFrame(id: number) {
    return this.delete('frame/Delete/'+ id);
  }
  deleteMountingDirection(id: number) {
    return this.delete('mountingDirection/Delete/'+ id);
  }
  deletesupportingConstruction(id: number) {
    return this.delete('supportingConstruction/Delete/'+ id);
  }
  deleteGlassBehaviour(id: number) {
    return this.delete('glassBehavior/Delete/'+ id);
  }
  
  deleteFrameName(id: number) {
    return this.delete('frameName/Delete/'+ id);
  }
  deleteFrameMaterial(id: number) {
    return this.delete('frameMaterial/Delete/'+ id);
  }

  deleteGlassCoatingCode(id: number) {
    return this.delete('glassCoatingCode/Delete/'+ id);
  }

  deleteGlassManufacturer(id: number) {
    return this.delete('glassManufacturer/Delete/'+ id);
  }

  deleteGlassType(id: number) {
    return this.delete('glassType/Delete/'+ id);
  }

  deleteGlassUnit(id: number) {
    return this.delete('glassUnit/Delete/'+ id);
  }

  deleteResultUnit(id: number) {
    return this.delete('resultUnit/Delete/'+ id);
  }

  deleteBeadPosition(id: number) {
    return this.delete('beadPosition/Delete/'+ id);
  }
  
  deleteCompomemtCausedFailure(id: number) {
    return this.delete('componentCausedFailure/Delete/'+ id);
  }

  deleteGroup(id: number) {
    return this.delete('group/Delete/'+ id);
  }

  deleteGroupType(id: number) {
    return this.delete('groupType/Delete/'+ id);
  }

  deleteInstitute(id: number) {
    return this.delete('institute/Delete/'+ id);     //dependent
  }

  deleteInstituteType(id: number) {
    return this.delete('instituteType/Delete/'+ id);
  }

  deleteOrganisational(id: number) {
    return this.delete('organisationalUnit/Delete/'+ id);
  }

  deletePartner(id: number) {
    return this.delete('partner/Delete/'+ id);    //dependent
  }

  deletePartnerType(id: number) {
    return this.delete('partnerType/Delete/'+ id);    //dependent
  }

  deletePerformanceCriteria(id: number) {
    return this.delete('performanceCriteria/Delete/'+ id);
  }

  deleteConfidentialityLvl(id: number) {
    return this.delete('confidentialityLvl/Delete/'+ id);
  }

  deleteOwnerType(id: number) {
    return this.delete('ownerType/Delete/'+ id);    //identity error
  }

  deletePrjPurpose(id: number) {
    return this.delete('prjPurpose/Delete/'+ id);   //indentity error
  }

  deletePrjStatus(id: number) {
    return this.delete('prjStatus/Delete/'+ id);   //indentity error
  }

  deleteRegion(id: number) {
    return this.delete('region/Delete/'+ id);
  }

  deleteStandard(id: number) {
    return this.delete('standard/Delete/'+ id);  // dependent
  }

  deleteTstPurpose(id: number) {
    return this.delete('tstPurpose/Delete/'+ id);
  }

  deleteTstType(id:number){
    return this.delete(`testType/Delete/` + id);  
  }

  deleteResultFailureReason(id: number) {
    return this.delete('resultFailureReason/Delete/'+ id);
  }
  //EndRegion Delete

}